function ensureNumber(value, fallback) {
    if (fallback === undefined) fallback = 0

    var n = Number(value)
    return Number.isFinite(n) ? n : fallback
}

function scaleValue(value, scale) {
    if (value === undefined || value === null) {
        return value
    }

    var n = Number(value)

    if (!Number.isFinite(n)) {
        return value
    }

    return n * scale
}

function createRenderer(options) {

    options = options || {}

    var designWidth = ensureNumber(options.designWidth, 1080)
    var designHeight = ensureNumber(options.designHeight, 868)

    var actualWidth = ensureNumber(options.actualWidth, designWidth)
    var actualHeight = ensureNumber(options.actualHeight, designHeight)
    var activeState = options.activeState || 'default'

    var scale = Math.min(
        actualWidth / designWidth,
        actualHeight / designHeight
    )

    var renderWidth = designWidth * scale
    var renderHeight = designHeight * scale

    var offsetX = (actualWidth - renderWidth) / 2
    var offsetY = (actualHeight - renderHeight) / 2

    function renderX(x) {
        return offsetX + ensureNumber(x) * scale
    }

    function renderY(y) {
        return offsetY + ensureNumber(y) * scale
    }

    function renderWidthValue(w) {
        return ensureNumber(w) * scale
    }

    function renderHeightValue(h) {
        return ensureNumber(h) * scale
    }

    function matchesTargetState(targetState) {

        if (!targetState || targetState === 'all') {
            return true
        }

        if (Array.isArray(targetState)) {
            return targetState.indexOf(activeState) !== -1
        }

        var raw = String(targetState)
        if (raw.indexOf(',') !== -1) {
            var states = raw.split(',').map(function (s) { return s.trim() }).filter(Boolean)
            return states.indexOf(activeState) !== -1
        }

        return raw === activeState
    }

    function isItemVisible(item) {

        if (!item) {
            return false
        }

        var visible = true
        var overrides = item.stateOverrides || {}
        var stateOverride = overrides && overrides[activeState]

        if (stateOverride && stateOverride.visible !== undefined && stateOverride.visible !== null) {
            visible = !!stateOverride.visible
        }

        var isOverlay =
            item.type === 'component' &&
            item.data &&
            item.data.id === 'overlay'

        if (isOverlay && item.overlayConfig && item.overlayConfig.targetState) {
            visible = visible && matchesTargetState(item.overlayConfig.targetState)
        }

        return visible
    }

    function isBackgroundAsset(item) {

        if (!item || item.type !== 'asset') {
            return false
        }

        if (item.isBackgroundLayer) {
            return true
        }

        var category = item.data && item.data.category
            ? String(item.data.category).toLowerCase()
            : ''

        var name = item.data && item.data.name
            ? String(item.data.name).toLowerCase()
            : ''

        return category.indexOf('background') !== -1 || name.indexOf('background') !== -1
    }

    function resolveAssetWidth(item) {

        if (isBackgroundAsset(item)) {
            return ensureNumber(item.originalWidth, designWidth)
        }

        var width = ensureNumber(item.width, 0)

        if (width <= 1) {
            var originalWidth = ensureNumber(item.originalWidth, 0)
            if (originalWidth > 1) {
                return originalWidth
            }
        }

        return width || 120
    }

    function resolveAssetHeight(item) {

        if (isBackgroundAsset(item)) {
            return ensureNumber(item.originalHeight, designHeight)
        }

        var height = ensureNumber(item.height, 0)

        if (height <= 1) {
            var originalHeight = ensureNumber(item.originalHeight, 0)
            if (originalHeight > 1) {
                return originalHeight
            }
        }

        return height || 120
    }

    function getItemStyle(item, index) {

        if (index === undefined) {
            index = 0
        }

        var props = item.properties || {}

        var isAsset = item.type === 'asset'

        var isOverlay =
            item.type === 'component' &&
            item.data &&
            item.data.id === 'overlay'

        var overlayConfig = {
            color: '#111111',
            opacity: 0.4,
            blendMode: 'multiply',
            width: 100,
            height: 100
        }

        if (item.overlayConfig) {
            for (var k in item.overlayConfig) {
                overlayConfig[k] = item.overlayConfig[k]
            }
        }

        var borderWidth = 0

        if (props.strokeMode === 'box') {

            var bw

            if (props.boxBorderWidth !== undefined && props.boxBorderWidth !== null) {
                bw = props.boxBorderWidth
            } else if (props.stroke !== undefined && props.stroke !== null) {
                bw = props.stroke
            } else {
                bw = 0
            }

            borderWidth = scaleValue(bw, scale)
        }

        var opacity = 1

        if (props.opacity !== undefined && props.opacity !== null) {
            opacity = props.opacity
        }

        return {

            left: renderX(item.position.x) + 'px',

            top: renderY(item.position.y) + 'px',

            width: isOverlay
                ? renderWidthValue(overlayConfig.width) + 'px'
                : isAsset
                    ? renderWidthValue(resolveAssetWidth(item)) + 'px'
                    : 'auto',

            height: isOverlay
                ? renderHeightValue(overlayConfig.height) + 'px'
                : isAsset
                    ? renderHeightValue(resolveAssetHeight(item)) + 'px'
                    : 'auto',

            zIndex: index + 1,

            backgroundColor:
                isOverlay
                    ? overlayConfig.color
                    : (
                        props.backgroundColor
                            ? props.backgroundColor
                            : (isAsset ? 'transparent' : '#FFFFFF')
                    ),

            opacity: isOverlay ? overlayConfig.opacity : opacity,

            borderWidth: borderWidth + 'px',

            borderColor:
                props.strokeColor ||
                props.fontColor ||
                '#000000',

            borderRadius:
                props.borderRadius !== undefined &&
                props.borderRadius !== null
                    ? scaleValue(props.borderRadius, scale) + 'px'
                    : undefined,

            boxShadow: props.boxShadow,

            transform:
                isOverlay
                    ? 'translate(-50%,0)'
                    : (
                        item.isBackgroundLayer
                            ? 'none'
                            : (
                                item.rotation
                                    ? 'rotate(' + item.rotation + 'deg)'
                                    : 'rotate(0deg)'
                            )
                    ),

            mixBlendMode:
                isOverlay
                    ? overlayConfig.blendMode
                    : undefined
        }
    }

    function getTextStyle(item) {

        var props = item.properties || {}

        var style = {

            fontFamily: props.fontFamily || 'Arial',

            fontSize: scaleValue(props.fontSize || 14, scale) + 'px',

            fontWeight: props.fontWeight || '400',

            color: props.fontColor || '#000',

            textAlign: props.alignment || 'center',

            letterSpacing:
                scaleValue(props.letterSpacing || 0, scale) + 'px',

            lineHeight:
                props.lineHeight
                    ? scaleValue(props.lineHeight, scale)
                    : 1.5,

            textShadow:
                props.shadow > 0
                    ? (
                        scaleValue(props.shadow, scale) + 'px ' +
                        scaleValue(props.shadow, scale) + 'px ' +
                        scaleValue(props.shadow * 2, scale) +
                        'px rgba(0,0,0,.3)'
                    )
                    : 'none'
        }

        if (
            (props.strokeMode === 'text' ||
                props.strokeMode === 'outline') &&
            props.stroke > 0
        ) {

            var s = scaleValue(props.stroke, scale)

            var c =
                props.strokeColor ||
                props.fontColor ||
                '#000'

            style.textShadow = [
                (-s) + 'px ' + (-s) + 'px 0 ' + c,
                '0 ' + (-s) + 'px 0 ' + c,
                s + 'px ' + (-s) + 'px 0 ' + c,
                (-s) + 'px 0 0 ' + c,
                s + 'px 0 0 ' + c,
                (-s) + 'px ' + s + 'px 0 ' + c,
                '0 ' + s + 'px 0 ' + c,
                s + 'px ' + s + 'px 0 ' + c
            ].join(', ')
        }

        return style
    }

    // Adjusts text style based on dynamic variable length changes.
    // digitDelta: shifts font size; short actual values (<3 chars): shifts text horizontally.
    function applyDynamicTextAdjustments(style, opts) {
        opts = opts || {};
        var designVars = opts.designVars || {};
        var actualVars = opts.actualVars || {};
        var rawText = String(opts.rawText || '');
        var isBuyItem = !!opts.isBuyItem;

        var digitDelta = 0;
        var hasMatch = false;
        var maxActualLen = 0;

        rawText.replace(/\{\{\s*([^}]+)\s*\}\}/g, function (m, v) {
            var varName = v.trim();
            var designVal = designVars[varName];
            var actualVal = actualVars[varName];
            if (designVal != null && actualVal != null) {
                digitDelta += String(designVal).length - String(actualVal).length;
                maxActualLen = Math.max(maxActualLen, String(actualVal).length);
                hasMatch = true;
            }
        });

        /*if (hasMatch && digitDelta !== 0) {
            var base = parseFloat(style.fontSize) || 14;
            style.fontSize = Math.max(8, 2 + base + digitDelta * 2) + 'px';
            var baseLH = parseFloat(style.lineHeight) || 1.5;
            style.lineHeight = Math.max(0.5, baseLH - digitDelta * 0.1 + 0.1);
        }*/

        return style;
    }

    // Shifts the parent item div horizontally based on resolved text length vs static prefix length.
    function applyDynamicPositionAdjustments(style, opts) {
        opts = opts || {};
        var resolvedText = String(opts.resolvedText || '');
        var templateText = String(opts.templateText || '').replace(/\s*\{\{/g, '{{');
        var dynamicValue = String(opts.dynamicValue || '');
        var designValue = String(opts.designValue || '');

        var hasDynamic = /\{\{\s*[^}]+\s*\}\}/.test(templateText);
        if (!hasDynamic) return style;

        var staticText = templateText.replace(/\{\{\s*[^}]+\s*\}\}/g, '').trim();
        var staticLen = staticText.length;
        var resolvedLen = resolvedText.length;
        var dynamicLen = dynamicValue.length;
        var designLen = designValue.length;

        //console.log('resolved:', resolvedText, '| dynamic:', dynamicValue, '| design:', designValue, '| static prefix:', staticText);

        if(dynamicLen < designLen) {
            var shiftLeft = (designLen - dynamicLen) * 8;
            style.left = (parseFloat(style.left) || 0) + shiftLeft + 'px';
        }
        else if(dynamicLen > designLen) {
            var shiftRight = (dynamicLen - designLen) * 8;
            style.left = (parseFloat(style.left) || 0) - shiftRight + 'px';
        }

        /*if (staticLen > 0 && staticLen < 3) {
            if(staticLen === 1) {
                var shiftLeft = (3 - staticLen) * 8;
                style.left = (parseFloat(style.left) || 0) - shiftLeft + 'px';
            } else if(staticLen === 2) {
                var shiftLeft = (3 - staticLen) * 12;
                style.left = (parseFloat(style.left) || 0) - shiftLeft + 'px';
            }
            

            var shiftTop = (3 - staticLen) * 4;
            style.top = (parseFloat(style.top) || 0) - shiftTop + 'px';
        }*/

        return style;
    }

    // Adjusts position for coins_1_value based on text length difference
    function applyTextLengthDifferenceAdjustment(style, opts) {
        opts = opts || {};
        var varName = String(opts.varName || '');
        var lengthDifference = Number(opts.lengthDifference) || 0;

        if (varName === 'coins_1_value' && lengthDifference !== 0) {
            var currentLeft = parseFloat(style.left) || 0;
            var adjustment = 150 - (lengthDifference * 10);
            style.left = (currentLeft + adjustment) + 'px';
            //console.log('[Position Adjustment] coins_1_value: current left=' + currentLeft + ', difference=' + lengthDifference + ', new left=' + (currentLeft + adjustment) + 'px');
        }

        return style;
    }

    return {

        scale: scale,

        offsetX: offsetX,

        offsetY: offsetY,

        renderX: renderX,

        renderY: renderY,

        renderWidth: renderWidthValue,

        renderHeight: renderHeightValue,

        scaleValue: scaleValue,

        isItemVisible: isItemVisible,

        getItemStyle: getItemStyle,

        getTextStyle: getTextStyle,

        applyDynamicTextAdjustments: applyDynamicTextAdjustments,

        applyDynamicPositionAdjustments: applyDynamicPositionAdjustments,

        applyTextLengthDifferenceAdjustment: applyTextLengthDifferenceAdjustment
    }
}

module.exports = {
    createRenderer: createRenderer
}


// WEBPACK FOOTER //
// ./src/utils/poRenderer.js